module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_eight_black_short-14ded4dea0199947b506ee063bbc72f2.svg";